import './index.css';
import View from '../view';
import Text from '../text';
import {
  getRouteObjByGame,
  getTeamA,
  getTeamB,
  isDesktopBrowser,
  isBannedStateForFantasySports,
  isSmartPhone
} from '../../utilities/helper';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CountdownTimer from '../countdown_timer';
import Constants from '../../constants';
import { customizeLeagueTitle } from '../../utilities/MatchTitleFormat';
import { Dots } from 'react-activity';
import useTheme from '../../utilities/hooks/theme';
import { showErrorToast, showToast } from '../../actions/app-actions-types';
import { fantasyMatchClick } from '../../actions/fantasy-cricket-action-types';
import { useLink } from 'react-router-stack';
import { updateGameType } from '../../actions/user-actions-types';
import I18n from '../../utilities/locale';
import React from 'react';
import { debounce } from 'lodash';
import constants from '../../constants';
const GAME_TYPE = Constants.GameType.FANTASY_CRICKET;

interface Props {
  matchItem: any;
  onCalledDeadline: any;
  theme: any;
  onPressPlay: any;
  dispatch: any;
}
const DashboardCricketMatchItem = ({
  dispatch,
  matchItem,
  onPressPlay,
  onCalledDeadline,
  theme
}: Props) => {
  const { preSquad = false, lineupsOut = false } = matchItem;
  const teamA = getTeamA(matchItem, GAME_TYPE) || {};
  const teamB = getTeamB(matchItem, GAME_TYPE) || {};
  const matchTitle = customizeLeagueTitle(matchItem);
  const _onCalledDeadline = () => {
    onCalledDeadline(matchItem);
  };
  const _proceedPlay = () => {
    if (preSquad) {
      onPressPlay({
        ...matchItem,
        teamA,
        teamB,
        matchTitle
      });
    } else dispatch(showToast('squad not out'));
  };
  const timerIconDimension = '15px';

  const matchTimer = {
    color: theme.dashboardMatchTimer
  };

  const lineUpOutColor = {
    color: theme.dashboardMatchLineUpOutTitle
  };

  const lineUpOutDots = {
    backgroundColor: theme.dashboardMatchLineUpOutTitle
  };
  let title = matchTitle;
  if (!isDesktopBrowser) title = title.substring(0, 25) + '...';

  const _onPressPlay = () => {
    _proceedPlay();
  };

  const cricketMatchCardStyle = {
    background: theme.cricketMatchCardBg,
    boxShadow: theme.cricketMatchCardBoxShadow,
    border: `1px solid ${theme.cricketMatchCardBorder}`
  };
  const cricketMatchCardContentText = {
    color: theme.cricketMatchCardText
  };
  return (
    <>
      <div
        className={
          isSmartPhone ? 'cricket_match_card_container_mWeb' : 'cricket_match_card_container'
        }
        style={cricketMatchCardStyle}
        onClick={_onPressPlay}>
        <img src={constants.Images.ShareIcon} className="shareIcon_img" />
        <div
          className={
            isSmartPhone
              ? 'cricketMatchCard__img__wrapper__mWeb'
              : 'cricketMatchCard__img__wrapper__web'
          }>
          <div className="cricket_match_card_team_img_container">
            <img src={`${Constants.FLAGS[teamA?.name.split(' ')[0]]}`} />
            {/* <View className={'dashboard-cricket-match-item-image-divider'} /> */}
            <img src={`${Constants.FLAGS[teamB?.name.split(' ')[0]]}`} />
          </div>
        </div>

        <div
          className={
            isSmartPhone ? 'cricketMatchCard__detail__mWeb' : 'cricketMatchCard__detail__web'
          }>
          <div
            className={
              isSmartPhone ? 'cricket_match_primary_detail_mWeb' : 'cricket_match_primary_detail'
            }>
            <span className="match_title">{`${teamA?.shortName} vs ${teamB?.shortName}`}</span>
            <span className="match_type" style={cricketMatchCardContentText}>{`${title}`}</span>
          </div>
          <div>
            <div
              className={
                isSmartPhone
                  ? 'cricket_match_secondary_detail_mWeb'
                  : 'cricket_match_secondary_detail'
              }
              style={cricketMatchCardContentText}>
              <div className="flex-row">
                {isSmartPhone ? (
                  <Constants.Svgs.TimerMobile />
                ) : (
                  <Constants.Svgs.Timer width={timerIconDimension} height={timerIconDimension} />
                )}
                <CountdownTimer
                  style={{
                    fontFamily: 'ProximaNova-SemiBold',
                    fontSize: '0.85rem',
                    paddingLeft: '4px',
                    marginBottom: 0,
                    textAlign: 'center',
                    // color: 'fff',
                    ...matchTimer
                  }}
                  onCalledDeadline={_onCalledDeadline}
                  isShowAlert={false}
                  matchItem={matchItem}
                  gameType={GAME_TYPE}
                />
                {lineupsOut && (
                  <View className={'dashboard-cricket-match-lineup-out-container'}>
                    <View style={lineUpOutDots} className={'dashboard-cricket-match-lineup-out'} />
                    <Text
                      style={lineUpOutColor}
                      className={'dashboard-cricket-match-lineup-out-title'}>
                      {I18n.t('LineupOut')}
                    </Text>
                    <View style={lineUpOutDots} className={'dashboard-cricket-match-lineup-out'} />
                    <View />
                  </View>
                )}
              </div>
              <div className="flex-row" style={{ paddingTop: '4px' }}>
                <img
                  src={Constants.Images.coin}
                  width={timerIconDimension}
                  height={timerIconDimension}
                />
                <p style={{ paddingLeft: '2px' }}>1,00,000</p>
              </div>
            </div>
          </div>
        </div>
        {!isSmartPhone && (
          <div className="cricket_match_play_btn_wrapper">
            <button className="play_btn" onClick={_onPressPlay}>
              PLAY
            </button>
          </div>
        )}
      </div>
    </>
  );
};
const DashboardCricketMatch = () => {
  const navigate = useLink();
  const app = useSelector((state: any) => state.app);
  const { list: fantasyCricketList = {} } = useSelector((state: any) => state.fantasy_cricket);
  const { fixtures: fantasyCricketFixtureList = [] } = fantasyCricketList;

  const [upcomingMatchList] = useState([...fantasyCricketFixtureList]);
  const [loading, setLoading] = useState(false);
  const { currentLocationState = '' } = app;
  const { DashboardTheme: theme } = useTheme();
  const dispatch = useDispatch();
  const delayedData = useCallback(
    debounce(() => getData(), 10),
    []
  );

  useEffect(() => {
    delayedData();
  }, []);

  const getData = async () => {
    setLoading(false);
  };

  const renderItem = (item: any) => {
    return (
      <DashboardCricketMatchItem
        key={item._id}
        matchItem={item}
        onCalledDeadline={onCalledDeadline}
        theme={theme}
        onPressPlay={onPressPlay}
        dispatch={dispatch}
      />
    );
  };

  const onCalledDeadline = () => {
    delayedData();
  };

  const onPressPlay = (matchItem: any) => {
    const isBanned = isBannedStateForFantasySports(currentLocationState);
    if (!isBanned) {
      dispatch(
        fantasyMatchClick({
          data: {
            ...matchItem,
            completed: false,
            joined: false,
            joinedMatch: false,
            contestId: '',
            entryFee: '',
            isTeamSwitch: false,
            tabType: 'FIXTURE'
          }
        })
      );
      // dispatch(setMyTeamList([]));
      // dispatch(setMyContestList([]));
      dispatch(updateGameType(Constants.GameType.FANTASY_CRICKET));
      navigate.push(getRouteObjByGame(GAME_TYPE)['home_tab']);
    } else {
      let message = 'Sorry, this game is not playable in your location ';
      message += currentLocationState ? `"${currentLocationState}".` : '.';
      dispatch(showErrorToast(message));
    }
  };

  const matchTitle = {
    color: theme.dashboardMatchTitle
  };

  return (
    <>
      {loading ? (
        <View className={'dashboard-cricket-match-loading'}>
          <Dots color={theme.dashboardMatchTitle} />
          <Text style={matchTitle} className={'dashboard-cricket-match-title'}>
            {'Fetching Upcoming Cricket Matches'}
          </Text>
        </View>
      ) : upcomingMatchList.length > 0 ? (
        <>
          <div
            className={
              isSmartPhone ? 'cricket_match_card_wrapper_mWeb' : 'cricket_match_card_wrapper'
            }>
            {upcomingMatchList.map(renderItem)}
          </div>
        </>
      ) : null}
    </>
  );
};
export default React.memo(DashboardCricketMatch);
